import { getActionTypes } from '../../../utils/reduxHelper';
import storage from '../../../utils/storage';

export const actions = getActionTypes('auth', ['CREATE']);

export const initialAuthState = {
    authToken: storage.getToken() || undefined,
    userDetails: storage.get('userDetails') || null,
    error: undefined,
};
